import { ADTYPE_REDEEM, ADTYPE_DONATION, ADTYPE_EVENT } from "../../../../utils/constants";
import * as types from './types';

const defaultState = {
    adsList: [],
    draggableTable: {
        tableHeaders: [
            { width: '35%', label: "Title" },
            { width: '20%', label: "Start Date" },
            { width: '20%', label: "End Date" },
            { width: '25%', label: "Actions" }
        ],
        tableColumns: [
            "adsTitle",
            "startDate",
            "endDate"
        ]
    },
    adsForm: {
        model: "AdsModel",
        form: [
            {
                type: "text",
                label: "Advertisement Title",
                name: "adsTitle",
                placeholder: 'Enter advertisement title',
                default: '',
                required: true,
                md: 12,
                xs: 12,
                maxLength: 125
            },
            {
                type: "select",
                label: "Advertisement Type",
                name: "adTypeId",
                default: ADTYPE_REDEEM,
                required: true,
                md: 5,
                xs: 12,
            },
            {
                type: "dateRange", //data will be start date and end date
                required: true,
                default: '',
                md: 12,
                xs: 12
            },
            {
                type: "redemption",
                default: 0,
                label: "Redemption Limit",
                name: 'redemptionLimit',
                required: true,
                md: 6,
                xs: 12,
                min: 0,
                max: 99999999999,
                maxLength: 10
            },
            {
                type: "adsPrice",
                default: 0,
                label: "Ticket Price",
                name: 'adsPrice',
                required: true,
                md: 6,
                xs: 12,
                min: 0,
                max: 99999999999,
                maxLength: 10
            },
            {
                type: "editor",
                label: "Description",
                name: "adsDescription",
                required: true,
                default: '',
                md: 12,
                xs: 12
            },
        ]
    },

    adTypeSelection: [
        { name: "adTypeId", label: "Redeem", value: ADTYPE_REDEEM },
        { name: "adTypeId", label: "Event", value: ADTYPE_EVENT },
        { name: "adTypeId", label: "Donation", value: ADTYPE_DONATION },
    ],

    pendingTable: {
        tableHeaders: [
            "Title",
            "Start Date",
            "End Date",
            "Actions"
        ],
        tableColumns: [
            "adsTitle",
            "startDate",
            "endDate"
        ]
    },
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.SET_LIST:
            return { ...state, adsList: action.payload };
        default: return state;
    }
};